import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  useNavigate,
//   Link,
} from 'react-router-dom'
import Page from 'src/components/Page'
import {
  makeStyles,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  IconButton,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import moment from 'moment-jalaali'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
// import { ExpandLess as ExpandLessIcon } from '@material-ui/icons'
import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth'
import { ExpandLess as ExpandLessIcon } from '@material-ui/icons'
import { info } from '../../app/slices/snackSlice'
import {
  getUserCertificates,
  selectorUserCertificates,
} from '../../app/slices/courseSlice'
import userCertificateStatus from '../../constants/userCertificateStatus'

const columnsList = ['نام دوره', 'تاریخ درخواست گواهینامه', 'وضعیت']
const buttnList = {
  pay_pending: 'pay_pending',
  paid: 'paid',
  Sent: 'Sent',
  Delivered: 'Delivered',
}

// const alertList = {
//   completed: {
//     type: 'info',
//     text: 'با تشکر، داوران در حال بررسی آزمون شما هستند، پس از بررسی
//  مراتب به اطلاع شما خواهد رسید',
//   },
//   expired: {
//     type: 'warning',
//     text: (
//       <p>
//         مدت  زمان انجام آزمون منقضی شده است، لطفا مراتب را از&nbsp;
//         <Link to="/app/chats/user">پشتیبانی</Link>
//         &nbsp;پی گیری کنید
//       </p>
//     ),
//   },
//   resultReady: {
//     type: 'success',
//     text: (
//       <p style={{ width: '100%' }}>
//         نتیجه آزمون شما مشخص شده است.
//         <br />
//         <Link to="/app/scholarship" style={{ color:
// '#0043ff', fontWeight: 'bold' }}>فرم درخواست بورسیه</Link>
//       </p>
//     ),
//   },
// }

const alertList = {
  100: {
    type: 'warning',
    text: 'شما هنوز مبلغ گواهینامه را پرداخت نکرده اید',
  },
  101: {
    type: 'info',
    // text: 'شما هنوز در پروفایل خود را تکمیل نکرده اید',
    text: 'پرداخت شده',
  },
  102: {
    type: 'success',
    text: 'ارسال شده',
  },
  103: {
    type: 'success',
    text: 'تحویل داده شده',
  },
  //   104: {
  //     type: 'info',
  //     text: 'روان‌شناسان گارنت در حال تحلیل و بررسی آزمون شما هستند.',

  //   },
  //   105: {
  //     type: 'success',
  //     text: (
  //       <p>
  //         نتیجه آزمون شما با تحلیل روان‌شناسان گارنت آماده شده و می‌توانید مشاهده کنید. &nbsp;
  //         <Link
  //           to="/app/scholarship"
  //           style={{ color: '#0043ff', fontWeight: 'bold' }}
  //         >
  //           فرم درخواست بورسیه

  //         </Link>
  //             &nbsp;را تکمیل کنید
  //       </p>
  //     ),
  //   },
  //   106: {
  //     type: 'success',
  //     text: 'پکیج شما منقضی شده است, جهت تمدید پکیج اقدام فرمایید',

  //   },
  //   107: {
  //     type: 'success',
  //     text: 'پکیج شما منقضی شده است, جهت تمدید پکیج اقدام فرمایید',

//   },
}

const useStyle = makeStyles((theme) => ({
  root: {
    padding: 10,
    '& .MuiAlert-message': {
      padding: '5 0 !important',
      width: '100%',
    },
    '& .MuiAlert-icon': {
      marginRight: '0 !important',
    },
    '& .MuiList-padding': {
      paddingBottom: '0 !important',
    },
  },
  title: {
    marginBottom: 15,
  },
  icon: {
  },
  list: {
    borderRadius: theme.spacing(1.25),
    boxShadow: '0 0 1px 0 rgba(26, 24, 24, 0.2)',
    backgroundColor: '#fff',
    marginBottom: theme.spacing(3.7),
  },
  listTitle: {
    fontSize: theme.spacing(2.5),
    fontWeight: 500,
    color: '#494949',
  },
  listItemData: {
    // maxWidth: '25%',
    textAlign: 'center',
    marginLeft: '-6px',
  },
  listItemPrimary: {
    fontSize: theme.spacing(2),
    fontWeight: 'normal',
    color: '#585858',
    width: '100%',
  },
  listItemPackageName: {
    textAlign: 'left',
  },
  packageStatus: {
    display: 'inline',
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1),
  },
  PayPending: {
    backgroundColor: '#e4006a',
  },
  paid: {
    backgroundColor: '#11a700',
  },
  Sent: {
    backgroundColor: '#11a700',
  },
  Delivered: {
    backgroundColor: '#11a700',
  },
  packageStatusText: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    color: '#ffffff',
  },
  btn: {
    borderRadius: theme.spacing(0.9),
    backgroundColor: '#405df0',
    '&:hover': {
      backgroundColor: '#10279b',
    },
  },
  expandBtn: {
  },
  btnLabel: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
    color: '#fff',
  },
  containerPortal: {
    maxWidth: theme.spacing(110),
    margin: 'auto',
  },
  expandLessIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: theme.spacing(4),
    borderEndStartRadius: theme.spacing(1),
    borderEndEndRadius: theme.spacing(0.7),
    cursor: 'pointer',
    marginTop: theme.spacing(1),
  },
  ListItemRespansive: {
    borderBottom: '0.5px solid #e7e7e7',
  },
  listItemDataRespansive: {
    textAlign: 'right',
  },
  alertList: {
    // marginBottom: theme.spacing(-1),
    borderBottomRightRadius: theme.spacing(1.25),
    borderBottomLeftRadius: theme.spacing(1.25),
  },
}))

// const PackageStatus = ({ status }) => {
//   const { t } = useTranslation()
//   const classes = useStyle()

//   return (
//     <div
//       className={classnames(classes.packageStatus, {
//         [classes[userCertificateStatus[status]]]: userCertificateStatus[status],
//       })}
//     >
//       <span className={classes.packageStatusText}>{t(userCertificateStatus[status])}</span>
//     </div>
//   )
// }

export const CertificateList = ({ width }) => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const { t } = useTranslation()
  //   const userPackages = useSelector(selectorUsersPackage)
  const [openPrtal, setOpenPortal] = React.useState({})
  const userCertificates = useSelector(selectorUserCertificates)
  console.log(t)

  useEffect(() => {
    if (!user.state) {
      dispatch(getUserCertificates())
    }
    if (!user?.profile?.isCompleted) {
      dispatch(info('برای شرکت در آزمون ابتدا می بایست پروفایل خود را تکمیل کنید'))
      navigate('/app/profile/edit')
    }
  }, [user])

  const handleBtnList = (index) => {
    setOpenPortal((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }
  const ButtnList = (pkg, i) => (Object.keys(buttnList).includes(userCertificateStatus[pkg?.status])
    ? (
      <>
        {
          openPrtal[i] ? (
            <IconButton
              onClick={() => handleBtnList(i)}
              className={classes.expandBtn}
            >
              <ExpandLessIcon />
            </IconButton>
          ) : (
            <Button
              classes={{
                root: classes.btn,
                label: classes.btnLabel,
              }}
              onClick={() => {
                if (userCertificateStatus[pkg?.status] === 'pay_pending') {
                  return handleBtnList(i)
                } if (!user?.profile?.isCompleted) {
                  return navigate('/app/profile/edit')
                }
                return navigate('/app')
              }}
            >
              {t(buttnList[userCertificateStatus[pkg?.status]])}
            </Button>
          )
        }
      </>
    ) : (
      <>
        <Alert
          style={{
            padding: '0 !important',
            width: '100% !important',
            display: 'flex',
            justifyContent: 'center',
          }}
          classes={{ root: classes.alertList }}
          severity={alertList[pkg?.status]?.type}
        >
          <AlertTitle style={{ padding: '0 !important' }}>توجه</AlertTitle>
          {alertList[pkg?.status]?.text}
        </Alert>
      </>
    ))

  return (
    <Page
      className={classes.root}
      title="گواهینامه ها"
    >
      {userCertificates?.length ? (
        <Grid className={classes.root}>
          <Grid container justify="space-between" className={classes.title}>
            <Typography variant="h2" component="h2">گواهینامه ها</Typography>
          </Grid>

          {
          isWidthUp('md', width) && (
          <List component="nav" classes={{ root: classes.list }}>
            <ListItem>
              {
                      columnsList.map((col, j) => (
                        <ListItemText
                          key={j}
                          classes={{
                            root: classnames(classes.listItemData,
                              {
                                [classes.listItemPackageName]: j === 0,
                              }),
                            primary: classes.listItemTitle,
                          }}
                          primary={col}
                        />
                      ))
                    }
            </ListItem>
            <Divider />
            {userCertificates?.map((certi, i) => {
              const lastIndex = userCertificates[userCertificates.length - 1]

              //   const customLink = ['report', certi?.id].join('/')

              // if (userState === 5) {
              //   customLink = '/app/courses/user/course-result'
              // } else if (userState === 4) {
              //   customLink = '/'
              // } else if (userState === 3) {
              //   customLink = pk?.exam?.type === 2 ?
              //  ['../exam', pk?.id].join('/') : [pk?.id].join('/')
              // } else if (userState === 2) {
              //   customLink = '/app/profile/edit'
              // }
              return (
                <>
                  <ListItem
                    key={i}
                    style={{ display: 'flex', width: '100%', justifyContent: 'flex-start' }}
                  >

                    <ListItemText
                      style={{
                        //   maxWidth: '28%'
                        display: 'flex',
                        margin: '0 auto',
                      }}
                      classes={{
                        root: classnames(classes.listItemPackageName, classes.listItemData),
                        primary: classes.listItemPrimary,
                      }}
                      primary={certi?.certificate?.title}
                    />
                    <ListItemText
                      style={{
                        maxWidth: '36%',
                        textAlign: 'center',
                      }}
                      classes={{
                        primary: classes.listItemPrimary,
                      }}
                      primary={(
                        <span style={{ margin: '0 auto !important' }}>
                          {certi?.createDate ? moment(certi?.createDate).format('jYYYY/jMM/jDD') : '---'}
                        </span>
)}
                    />

                    {/* <div
                      style={{
                        width: '30%',
                      }}
                    >
                      <Link
                        style={{
                          width: '35%',
                          display: 'flex',
                          margin: '0 auto',
                          backgroundColor: 'blue',
                          borderRadius: '10px',
                          padding: '10px',
                          color: 'white',
                          textAlign: 'center',
                          height: '42px',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        classes={{
                          root: classes.btn,
                          label: classes.btnLabel,
                        }}
                        to={customLink}
                      >
                        {user?.profile?.isCompleted && ButtnList(certi, i)}
                      </Link>
                    </div> */}

                    <ListItemText
                      style={{
                        width: '4%', display: 'flex', margin: '0 auto', justifyContent: 'end',
                      }}
                      classes={{
                        root: classes.listItemData,
                        primary: classes.listItemPrimary,
                      }}
                      primary={(
                        <p style={{ color: '#000' }}>
                          {user?.profile?.isCompleted && ButtnList(certi, i)}
                        </p>
                      )}
                    />
                  </ListItem>
                  {lastIndex !== userCertificates[i] && <Divider />}
                </>
              )
            })}
          </List>

          )
        }
          {
          isWidthDown('sm', width) && userCertificates?.map((certi, i) => {
            console.log(certi?.exam)
            // const link = pkg?.exam?.type === 2 ?
            //  ['../exam', pkg?.id].join('/') : [pkg?.id].join('/')
            return (
              <List component="nav" key={i} classes={{ root: classes.list }}>
                {
                  columnsList.map((col, j) => {
                    let primaryVal = ''
                    switch (j) {
                      case 0: primaryVal = certi?.certificate?.title
                        break
                      case 1: primaryVal = certi?.createDate ? moment(certi?.createDate).format('jYYYY/jMM/jDD') : '---'
                        break
                      case 2: primaryVal = ''
                        break
                      case 3: primaryVal = ButtnList(certi, i)
                        break
                      default: primaryVal = ''
                    }
                    return (
                      <ListItem key={j} classes={{ root: classes.ListItemRespansive }}>
                        <ListItemText
                          classes={{
                            primary: classes.listItemTitle,
                          }}
                          primary={col}
                        />
                        <ListItemText
                          classes={{
                            root: classes.listItemDataRespansive,
                            primary: classes.listItemPrimary,
                          }}
                          primary={primaryVal}
                        />
                      </ListItem>
                    )
                  })
                }
                <Divider />
                <div style={{ color: '#000' }}>
                  {ButtnList(certi, i)}
                </div>
              </List>
            )
          })
        }

        </Grid>
      ) : (
        <Alert
          style={{
            padding: '0 !important',
            width: '100% !important',
            display: 'flex',
            justifyContent: 'center',
          }}
          classes={{ root: classes.alertList }}
          severity="warning"
        >
          <AlertTitle style={{ padding: '0 !important' }}>توجه</AlertTitle>
          شما برای هیچ دوره ای درخواست گواهی نامه نداده اید
        </Alert>
      )}
    </Page>
  )
}

export default withWidth()(CertificateList)
